const SET_NEW_QUOTE_ID = 'set-new-quote-id-for-dropzone'
const RESET_QUOTE_ID = 'reset-quote-id-for-dropzone'

function getDefaultState() {
    return {
        newQuoteId: null,
    }
}

export function getNewQuoteIdForDropzone(state) {
    return state.quotes?.newQuoteId
}

// Antd Upload component only has a beforeUpload trigger which gets called
// before upload of each file. This reducer will help keep track of the
// newly created quote for dropzoned files.
export default function quoteForDropzone(state = getDefaultState(), action) {
    switch (action.type) {
        case SET_NEW_QUOTE_ID:
            return {
                ...state,
                newQuoteId: action.newQuoteId,
            }
        case RESET_QUOTE_ID:
            return {
                ...state,
                newQuoteId: null,
            }

        default:
            return state
    }
}

export function setNewQuoteIdForDropzone({ id }) {
    return {
        type: SET_NEW_QUOTE_ID,
        newQuoteId: id,
    }
}

export function resetQuoteIdForDropzone() {
    return {
        type: RESET_QUOTE_ID,
        newQuoteId: null,
    }
}
